import { Role } from '@/shared/lib/types/admin';
import BreadcrumbLink from '@/shared/ui/components/BreadcrumbLink';
import RequireRole from '@/shared/ui/components/RequireRole';
import type { RoutePathDefinition } from '../../types';

export const rpmSectionRoutes: RoutePathDefinition[] = [
  {
    path: 'my-patients',
    lazy: () => import('@/pages/remote-patient-monitoring/ui/RpmMyPatients').then(m => ({ Component: m.default })),
    handle: { crumb: () => <BreadcrumbLink>RPM Patients</BreadcrumbLink> }
  },
  {
    path: 'provider-approvals',
    lazy: () => import('@/pages/care-management/ui/provider-approvals').then(m => ({ Component: m.default })),
    handle: { crumb: () => <BreadcrumbLink>Provider Approvals</BreadcrumbLink> }
  },
  {
    path: 'claims',
    // One's own pharmacy's claims: Super Admin, and Admin / Pharmacist Admin read-only (z93r0b76qr).
    lazy: () =>
      import('@/pages/care-management/ui/claims').then(m => ({
        Component: () => (
          <RequireRole roles={[Role.SUPER, Role.ADMIN, Role.PHARMACIST_ADMIN]}>
            <m.default />
          </RequireRole>
        )
      })),
    handle: { crumb: () => <BreadcrumbLink>Claims</BreadcrumbLink> }
  },
  {
    path: 'alerts',
    lazy: () => import('@/pages/care-management/ui/alerts').then(m => ({ Component: m.default })),
    handle: { crumb: () => <BreadcrumbLink>Alerts</BreadcrumbLink> }
  },
  {
    path: 'devices',
    lazy: () => import('@/pages/care-management/ui/devices').then(m => ({ Component: m.default })),
    handle: { crumb: () => <BreadcrumbLink>Devices</BreadcrumbLink> }
  },
  {
    path: 'reports-communication',
    lazy: () => import('@/pages/care-management/ui/reports-communication').then(m => ({ Component: m.default })),
    handle: { crumb: () => <BreadcrumbLink>Reports Communication</BreadcrumbLink> }
  },
  {
    path: 'patient-schedules',
    lazy: () => import('@/pages/care-management/ui/patient-schedules').then(m => ({ Component: m.default })),
    handle: { crumb: () => <BreadcrumbLink>Patient Schedules</BreadcrumbLink> }
  },
  {
    path: 'follow-up-tasks',
    lazy: () => import('@/pages/care-management/ui/follow-up-tasks').then(m => ({ Component: m.default })),
    handle: {
      crumb: () => <BreadcrumbLink>My Tasks: Follow-up</BreadcrumbLink>
    }
  },
  {
    path: 'review-patients',
    lazy: () => import('@/pages/care-management/ui/chart-review').then(m => ({ Component: m.default })),
    handle: { crumb: () => <BreadcrumbLink>Chart Review</BreadcrumbLink> }
  }
];
